import Api from '@/plugins/axios';
import { VUE_APP_GCN_SERVICES } from '@/constants';
import {
  FindParecerReferencialPublicoRequestDTO,
  ParecerReferencialPublicoResponseDTO,
} from '@/views/publico-parecer-referencial/types';

const BASE_URL = `${VUE_APP_GCN_SERVICES}/publico/parecer_referencial`;

class PublicoParecerReferencialService {
  public async consultar(
    parecerReferencialFiltro: FindParecerReferencialPublicoRequestDTO
  ) {
    return Api.get<ParecerReferencialPublicoResponseDTO>(`${BASE_URL}/listar`, {
      params: parecerReferencialFiltro,
    });
  }

  public getUrlDownload(idParecerReferencial: string) {
    return `/gcn-services/api/publico/parecer_referencial/${idParecerReferencial}/documento`;
  }
}

export default new PublicoParecerReferencialService();
